<app-inventory-menu></app-inventory-menu>

<router-outlet></router-outlet>
